<button
  type="button"
  class="hk-trigger"
  (click)="hotkeyHelpService.toggle()"
  pTooltip="Keyboard shortcuts (Ctrl + /)"
  tooltipPosition="left"
  aria-label="Keyboard shortcuts"
>
  <span class="hk-trigger__icon"><i class="pi pi-list-check"></i></span>
  <span class="hk-trigger__label">Shortcuts</span>
  <span class="hk-trigger__keys">
    <kbd>Ctrl</kbd><span class="hk-key-sep">+</span><kbd>/</kbd>
  </span>
</button>

<div
  #backdropRef
  class="hk-backdrop"
  *ngIf="visible"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="hk-dialog-title"
>
  <div class="hk-dialog" (click)="$event.stopPropagation()">
    <header class="hk-dialog__header">
      <div class="hk-dialog__title-wrap">
        <span class="hk-dialog__icon"><i class="pi pi-list-check"></i></span>
        <div>
          <h2 id="hk-dialog-title" class="hk-dialog__title">Keyboard Shortcuts</h2>
          <p class="hk-dialog__subtitle">
            {{ totalCount }} shortcuts · Press <kbd>Esc</kbd> to close
          </p>
        </div>
      </div>
      <button type="button" class="hk-dialog__close" (click)="close()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="hk-sheet" *ngIf="groups.length; else empty">
      <section
        class="hk-sheet__section"
        *ngFor="let group of groups"
        [class.hk-sheet__section--wide]="group.wide"
      >
        <div class="hk-sheet__label">
          <i class="pi" [ngClass]="group.icon"></i>
          <span>{{ group.title }}</span>
          <span class="hk-sheet__count">{{ group.items.length }}</span>
        </div>

        <div class="hk-sheet__items">
          <div class="hk-item" *ngFor="let hk of group.items">
            <div class="hk-item__main">
              <span class="hk-item__icon"><i class="pi" [ngClass]="hk.icon"></i></span>
              <span class="hk-item__desc">{{ hk.description || 'Shortcut' }}</span>
            </div>
            <span class="hk-item__keys" [attr.aria-label]="formatKeyLabel(hk.key)">
              <ng-container *ngFor="let part of formatKeyParts(hk.key); let last = last">
                <kbd>{{ part }}</kbd>
                <span class="hk-key-sep" *ngIf="!last">+</span>
              </ng-container>
            </span>
          </div>
        </div>
      </section>
    </div>

    <ng-template #empty>
      <div class="hk-empty">
        <i class="pi pi-inbox"></i>
        <span>No shortcuts registered for this session.</span>
      </div>
    </ng-template>
  </div>
</div>
